import { useEffect, useState } from 'react';
import { api } from '@/utils/api';
import { MyProjectCard } from './MyProjectCard';
import { Link, useLocation } from 'react-router-dom';
import { effectiveTier, getStoredUser } from '@/utils/roleGate';

export function MyJobsPage() {
  const [projects, setProjects] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const location = useLocation() as { state?: { notice?: string } | null };
  const notice = location.state?.notice;
  // SOL-004 fix — truthful copy: the server scopes this list per role
  // (worker tier = ACTIVE assignments only; foreman+ = company-wide), so the
  // page must not claim company-wide rows are "assigned to you".
  const isWorkerTier = effectiveTier(getStoredUser().role) === 'CREW_MEMBER';

  useEffect(() => {
    api.get('/projects')
      .then((response: any) => setProjects(response.data?.data ?? response.data ?? []))
      .catch((err: any) => setError(err?.response?.data?.message || 'Could not load your jobs.'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <main className="min-h-screen bg-gray-50 px-6 py-8">
      <div className="max-w-7xl mx-auto">
        <Link to="/dashboard" className="text-sm text-blue-600 hover:underline">← Dashboard</Link>
        <h1 className="text-3xl font-bold text-gray-900 mt-4">My Jobs</h1>
        <p className="text-gray-600 mt-1 mb-8">
          {isWorkerTier ? 'Projects assigned to you' : 'Projects in your company'}
        </p>
        {notice && (
          <p className="mb-6 p-3 bg-amber-50 border border-amber-200 rounded-lg text-amber-800 text-sm">
            {notice}
          </p>
        )}
        {loading && <p className="text-gray-600">Loading your jobs...</p>}
        {error && <p className="text-red-600">{error}</p>}
        {!loading && !error && projects.length === 0 && (
          <p className="text-gray-600">
            {isWorkerTier
              ? 'No active project assignments — your supervisor adds you to a job and it appears here.'
              : 'No projects yet — create one from the Projects page.'}
          </p>
        )}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {projects.map((project) => <MyProjectCard key={project.id} project={project} />)}
        </div>
      </div>
    </main>
  );
}
